import { z } from 'zod';

export function conditionToZodSchema(value: unknown): z.ZodTypeAny {
    if (['string', 'number', 'boolean', 'bigint', 'symbol'].includes(typeof value)) {
        return z.literal(value as z.util.Literal);
    }

    if (value === undefined) {
        return z.literal(undefined);
    }

    if (typeof value !== 'object') {
        throw new Error(
            `Unsupported condition of type "${typeof value}" with value ${JSON.stringify(value)}`,
        );
    }

    if (value === null) {
        return z.null();
    }

    if (Array.isArray(value)) {
        if (value.length === 0) {
            return z.array(z.never()).max(0).nullable().optional();
        } else if (value.length === 1) {
            return z.array(conditionToZodSchema(value[0])).min(1);
        } else {
            return z
                .array(
                    z.union(
                        value.map<z.ZodTypeAny>((v) => conditionToZodSchema(v)) as [
                            z.ZodTypeAny,
                            z.ZodTypeAny,
                            ...z.ZodTypeAny[],
                        ],
                    ),
                )
                .min(1);
        }
    }

    return Object.entries(value)
        .reduce((schema, [key, value]) => {
            return schema.merge(z.object({ [key]: conditionToZodSchema(value) }));
        }, z.object({}))
        .passthrough();
}
